export default __webpack_public_path__ + "static/media/undraw_revenue_planning.f192eaeb.svg";